import { SegmentPage } from "@enums/segment"
import useAuth from "@hooks/use-auth"
import { trackCustomPageEvent } from "./custom-page-event"

type Props = {
  isAuthRule?: {
    loggedInEventName: SegmentPage
    loggedOutEventName: SegmentPage
  }
}

export const withCustomSegmentPageEvent = (Component: React.FC, { isAuthRule }: Props) => () => {
  const { isAuthenticated } = useAuth()
  if(isAuthRule) {
    trackCustomPageEvent(isAuthRule && isAuthenticated() ? isAuthRule.loggedInEventName : isAuthRule.loggedOutEventName)
  }

  return <Component />
}
